export var OrderStatuses = {
  AUTH_CHALLENGE: 'AUTH_CHALLENGE',
  AUTH_FINGERPRINT: 'AUTH_FINGERPRINT'
};
export var OrderCategories = {
  FINES: 'TICKETS',
  IPVA: 'IPVA',
  LICENSING: 'LICENSING',
  CAD: 'CAD',
  CARD_VERIFICATION: 'CARD_VERIFICATION'
};
export var PaymentCategories = {
  TICKETS: 'FINES',
  IPVA: 'IPVA',
  LICENSING: 'LICENSING',
  CARD_VERIFICATION: 'CARD_VERIFICATION',
  CAD: 'CAD'
};
//# sourceMappingURL=statuses.js.map